import { render, staticRenderFns } from "./ReportHealthAndSafetyManagementCost.vue?vue&type=template&id=f2ccabb6&scoped=true&"
import script from "./ReportHealthAndSafetyManagementCost.vue?vue&type=script&lang=js&"
export * from "./ReportHealthAndSafetyManagementCost.vue?vue&type=script&lang=js&"
import style0 from "./ReportHealthAndSafetyManagementCost.vue?vue&type=style&index=0&id=f2ccabb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ccabb6",
  null
  
)

export default component.exports